import { GetCollaboratorAction, GetIdeaAction, ListDepartmentsAction, ListCollaboratorsAction, SaveIdeaAction } from './../../store/action/BrainstormActions';
import { IdeaModel, CollaboratorModel, BranchModel, DepartmentModel, IdeaTeamModel, IdeaSuggestionModel } from './../../model/BrainstormModel';
import { Component, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Slides, ToastController, LoadingController, Loading } from 'ionic-angular';
import { Subscription } from '../../../node_modules/rxjs';
import { Store } from '../../../node_modules/@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { ListBranchesAction } from '../../store/action/BrainstormActions';
import { UserService } from '../../services/UserService';
import { BrainstormService } from './../../services/BrainstormService';
import { CronosFilePage } from '../cronos-file/cronos-file';

@IonicPage()
@Component({
  selector: 'page-brainstorm',
  templateUrl: 'brainstorm.html',
})
export class BrainstormPage {

  @ViewChild(Slides) slides: Slides;
  @ViewChild('fileUpload') file;
  
  public currentPage: number;
  public totalPages: number;
  public paginationVisible: boolean;
  public paginationPreviousVisible: boolean;
  public paginationNextVisible: boolean;
  public defaultSelectOptions = { title: 'Selecione' };
  public fileInfo: string = null;
  public addingParticipant: boolean = false;
  public participante: IdeaTeamModel = null;
  public errorMessage: number = null;

  public ideaData: IdeaModel;
  public collaboratorData: CollaboratorModel;
  public branchesData: Array<BranchModel>;
  public departmentsData: Array<DepartmentModel>;
  public branchesTeamData: Array<BranchModel>;
  public departmentsTeamData: Array<DepartmentModel>;
  public collaboratorsTeamData: Array<CollaboratorModel>;
  public ideaId: number;
  public sugestoesValidas: Array<IdeaSuggestionModel> = [
    { sugestao: 'Reduz Custo' }, 
    { sugestao: 'Melhora Qualidade' }, 
    { sugestao: 'Aumenta Produtividade' }, 
    { sugestao: 'Melhora a Seguranca' }, 
    { sugestao: 'Melhora Ambiente de Trabalho' }, 
    { sugestao: 'Replicavel' }, 
    { sugestao: 'Inovadora' }, 
    { sugestao: 'Alinhada com tema sugerido pela empresa' }, 
    { sugestao: 'Aumentar vendas' }, 
    { sugestao: 'Aumentar margens' }, 
    { sugestao: 'Outras' }
  ];

  private userSubscription: Subscription;
  private brainstormSubscription: Subscription;
  
  private isLoading: boolean;
  private loader: Loading;
  private userId: number;
  private userEmail: string;
  private colaboradorId: number;
  private clientId: number;
  private loadingTeamDepartments: boolean = false;
  private saving: boolean = false;
  private collaboratorLoaded: boolean;
  private branchesLoaded: boolean;
  private ideaLoaded: boolean;
  private departmentsLoaded: boolean;
  private teamCollaboratorsLoaded: boolean;
  private loadingSuperior: boolean = false;
  private loadingImplementer: boolean = false;
  private fileToUpload: File = null;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public element: ElementRef,
    private store: Store<AppStore>,
    private cd: ChangeDetectorRef,
    private userService: UserService,
    private brainstormService: BrainstormService
  ) {      
    
  }

  ionViewDidLoad() {

    this.isLoading = false;
    this.saving = false;
    this.collaboratorLoaded = false;
    this.branchesLoaded = false;
    this.departmentsLoaded = false;
    this.loadingSuperior = false;
    this.loadingImplementer = false;

    if (this.navParams.get('id') != null) {
      this.ideaLoaded = false;
      this.totalPages = 3;
      this.ideaId = this.navParams.get('id');
      this.ideaData = null;
    } else {
      this.totalPages = 5;
      this.ideaId = null;
      this.ideaLoaded = true;
      this.ideaData = {
        id: null,
        clienteId: null,
        identificacao: null,
        sugestao: 0,
        colaboradorId: null,
        colaboradorEmail: null,
        colaboradorSuperior: null,
        colaboradorSuperiorId: null,
        unidadeId: null,
        departamentoId: null,
        ideia: null,
        ganhoResultadoEsperado: null,
        liderColaboradorId: null,
        analise: null,
        acao: null,
        querImplementar: false,
        sugestoes: [],
        times: [],
        arquivoIdeia: null,
        dataEnvio: null,
        usuarioId: null,
        usuarioEmail: null,
        usuarioSuperiorId: null
      }
    }

    this.currentPage = 1;
    this.paginationVisible = true;
    this.paginationPreviousVisible = false;
    this.paginationNextVisible = true;
    this.fileInfo = null;

    this.collaboratorData = null;

    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.userEmail = userState.user.email;
        if (userState.contributor != null) {
          this.colaboradorId = userState.contributor.id;
        } else {
          this.collaboratorData = {
            id: null,
            clienteId: null,
            usuarioId: null,
            organizacaoId: null,
            unidadeId: null,
            departamentoId: null,
            grupoId: null,
            usuario: userState.user,
            usuarios: null,
            organizacao: null,
            unidade: null,
            departamento: null,
            grupo: null,
            responsavel: null,
            email: null,
            emailAdmin: null,
            nome: null,
            dataCadastro: null,
            deleted: null,
            inactive: null
          }
        }
        this.clientId = userState.user.clienteId;
      }
      if (this.ideaId != null) {
        this.store.dispatch(new GetIdeaAction({ ideaId: this.ideaId }));
      } else {
        this.store.dispatch(new ListBranchesAction({ clientId: this.clientId }));
      }
    });

    this.brainstormSubscription = this.store.select('brainstormState').subscribe(brainstormState => {
      if ((brainstormState.loadingGetCollaborator || brainstormState.loadingListBranches || 
        brainstormState.loadingListDepartments || brainstormState.loadingListCollaborators ||
        brainstormState.loadingGetIdea || brainstormState.loadingSaveIdea) && !this.isLoading) {
        if (this.loader == null) {
          this.loader = this.loadingCtrl.create({
            content: 'Aguarde...'
          });
          this.loader.present();
        }
        this.isLoading = true;
      }
      if (!brainstormState.loadingGetCollaborator && !brainstormState.loadingListBranches && !brainstormState.loadingListDepartments &&
        !brainstormState.loadingListCollaborators && !brainstormState.loadingGetIdea && !brainstormState.loadingSaveIdea && this.isLoading) {
        this.loader.dismiss();
        this.loader = null;
        this.isLoading = false;
      }
      if (brainstormState.errorGetCollaborator || brainstormState.errorListBranches || brainstormState.errorGetIdea) { 
        this.presentToast('Erro ao carregar os dados');
      }
      if (brainstormState.errorListDepartments) {
        this.presentToast('Erro ao carregar os departamentos da unidade');
      }
      if (brainstormState.errorListCollaborators) {
        this.presentToast('Erro ao carregar os colaboradores do departamento');
      }
      if (brainstormState.errorSaveIdea) {
        this.presentToast('Erro ao gravar a ideia');
      }
      if (!this.ideaLoaded && !brainstormState.loadingGetIdea && !brainstormState.errorGetIdea && brainstormState.ideaData != null) {
        this.ideaData = brainstormState.ideaData;
        if (this.ideaData.sugestao == 1) {
          this.ideaData.times.forEach(item => {
            this.userService.getUser(item.usuarioId).subscribe(data => {
              item.nome = data.nome;
            });
          });
        }
        if (this.ideaData.arquivoIdeia != null) {
          const jsonArquivoIdeia = JSON.parse(this.ideaData.arquivoIdeia);
          if (jsonArquivoIdeia != null && jsonArquivoIdeia.nome != null) {
            this.fileInfo = jsonArquivoIdeia.nome;
          }
        }
        this.ideaLoaded = true;
        this.store.dispatch(new ListBranchesAction({ clientId: this.clientId }));
      }
      if (this.ideaLoaded && !this.branchesLoaded && !brainstormState.loadingListBranches && !brainstormState.errorListBranches && brainstormState.branchesData != null) {
        this.branchesLoaded = true;
        this.branchesData = brainstormState.branchesData;
        this.branchesTeamData = brainstormState.branchesData;
        if (this.colaboradorId != null) {
          this.store.dispatch(new GetCollaboratorAction({ collaboratorId: this.colaboradorId }));
        } else {
          this.collaboratorLoaded = true;
        }
      }
      if (this.ideaLoaded && this.branchesLoaded && !this.collaboratorLoaded && !brainstormState.loadingGetCollaborator && !brainstormState.errorGetCollaborator && brainstormState.collaboratorData != null) {
        if (this.loadingSuperior == true) {
          this.loadingSuperior = false;
          this.ideaData.usuarioSuperiorId = brainstormState.collaboratorData.usuarioId;
          this.ideaData.colaboradorSuperior = brainstormState.collaboratorData.usuario.nome;
        } else if (this.loadingImplementer == true) {
          this.loadingImplementer = false;
          this.ideaData.analise.implementador = brainstormState.collaboratorData.usuario.nome;
          if (this.ideaId != null) {
            this.setSuperior();
          }
        } else {
          this.collaboratorData = brainstormState.collaboratorData;
          if (this.ideaId != null) {
            this.ideaData.usuarioId = this.collaboratorData.usuarioId;
            this.ideaData.usuarioEmail = this.collaboratorData.usuario.email;
            this.loadDepartments();
          }
        }
        this.collaboratorLoaded = true;
      }
      if (this.ideaLoaded && this.branchesLoaded && this.collaboratorLoaded && !this.departmentsLoaded && !brainstormState.loadingListDepartments && !brainstormState.errorListDepartments && brainstormState.departmentsData != null) {
        if (this.loadingTeamDepartments) {
          this.loadingTeamDepartments = false;
          this.departmentsTeamData = brainstormState.departmentsData;
        } else {
          this.departmentsData = brainstormState.departmentsData;
          if (this.ideaId != null) {
            if (this.ideaData.analise != null && this.ideaData.analise.status == true) {
              this.setImplementer();
            } else {
              this.setSuperior();
            }
          }
        }
        this.departmentsLoaded = true;        
      }
      if (!this.teamCollaboratorsLoaded && !brainstormState.loadingListCollaborators && !brainstormState.errorListCollaborators && brainstormState.collaboratorsData != null) {
        this.teamCollaboratorsLoaded = true;
        this.collaboratorsTeamData = brainstormState.collaboratorsData;
      }
      if (this.saving && !brainstormState.loadingSaveIdea && !brainstormState.errorSaveIdea && brainstormState.savedIdeaData != null) {
        if (this.fileToUpload != null) {
          if (this.loader == null) {
            this.loader = this.loadingCtrl.create({
              content: 'Aguarde...'
            });
            this.loader.present();
          }
          this.brainstormService.saveFile(this.fileToUpload, brainstormState.savedIdeaData)
            .subscribe(res => {
              this.loader.dismiss();
              this.loader = null;
              this.presentToast('Ideia enviada com sucesso! Identificação: ' + brainstormState.savedIdeaData.identificacao);
              this.saving = false;
              this.navCtrl.popToRoot();
            }, err => {
              this.loader.dismiss();
              this.loader = null;
              this.presentToast('Ideia enviada com sucesso, porém houve um erro ao enviar o arquivo! Identificação: ' + brainstormState.savedIdeaData.identificacao);
              this.saving = false;
              this.navCtrl.popToRoot();
            });
        } else {
          this.presentToast('Ideia enviada com sucesso! Identificação: ' + brainstormState.savedIdeaData.identificacao);
          this.saving = false;
          this.navCtrl.popToRoot();
        }
      }
      if (this.collaboratorData != null && this.branchesData != null && this.ideaId != null) {
        setTimeout(() => {  
          this.slides.lockSwipes(true);
        }, 500);
      }
    });
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.brainstormSubscription != null) this.brainstormSubscription.unsubscribe();
  }

  getColor(ideia: IdeaModel) {
    const todayDate = new Date();
    if (ideia.acao != null) {
      if (ideia.acao.ideiaAplicavel == null) {
				if (ideia.acao.prazoEstimado != null) {
          const prazo = new Date(ideia.acao.prazoEstimado);
          if (prazo < todayDate) {
						return 'attention';
					} else {
						return 'primary';
					}
				} else {
					return 'danger';
				}
			} else if (ideia.acao.ideiaAplicavel == true) {
				return 'secondary';
			} else if (ideia.acao.ideiaAplicavel == false) {
				return 'danger';
			}
    } else if (ideia.analise != null) {
      if (ideia.analise.prazoAnalise != null) {
				const prazoAnalise = new Date(ideia.analise.prazoAnalise);
				if (prazoAnalise < todayDate) {
					return 'attention';
				} else {
					return 'primary';
				}
			} else {
				return 'danger';
			}
    } else {
      return 'disabled';
    }
  }

  getDescription(ideia: IdeaModel) {
    const todayDate = new Date();
    if (ideia.acao != null) {
      if (ideia.acao.ideiaAplicavel == null) {
				if (ideia.acao.prazoEstimado != null) {
          const prazo = new Date(ideia.acao.prazoEstimado);
          if (prazo < todayDate) {
						return 'Atrasado na ação';
					} else {
						return 'Em Ação';
					}
				} else {
					return 'Reprovada na implementação';
				}
			} else if (ideia.acao.ideiaAplicavel == true) {
				return 'Concluida';
			} else if (ideia.acao.ideiaAplicavel == false) {
				return 'Reprovada no encerramento';
			}
    } else if (ideia.analise != null) {
      if (ideia.analise.prazoAnalise != null) {
				const prazoAnalise = new Date(ideia.analise.prazoAnalise);
				if (prazoAnalise < todayDate) {
					return 'Atrasado na implementação';
				} else {
					return 'Em implementação';
				}
			} else {
				return 'Reprovada após análise';
			}
    } else {
      return 'Em análise';
    }
  }

  loadDepartments() {
    this.departmentsLoaded = false;
    this.errorMessage = null;
    this.store.dispatch(new ListDepartmentsAction({ branchId: this.ideaData.unidadeId }));
  }

  setSuperior() {
    this.collaboratorLoaded = false;
    this.loadingSuperior = false;
    this.errorMessage = null;
    const selectedDepartment = this.departmentsData.find(x => x.id == this.ideaData.departamentoId);
    if (selectedDepartment != null) {
      this.loadingSuperior = true;
      this.store.dispatch(new GetCollaboratorAction({ collaboratorId: selectedDepartment.colaboradorId }));
    }
  }

  setImplementer() {
    this.collaboratorLoaded = false;
    this.loadingImplementer = true;
    this.errorMessage = null;
    this.store.dispatch(new GetCollaboratorAction({ collaboratorId: this.ideaData.analise.implementadorId }));
  }

  isSuggestionSelected(sugestao: string): boolean {
    return this.ideaData.sugestoes.find(x => x.sugestao == sugestao) != null;
  }

  selectSuggestion(sugestao: IdeaSuggestionModel, e: any) {
    if (e.checked) {
      this.ideaData.sugestoes.push(sugestao);
    } else {
      const idx = this.ideaData.sugestoes.findIndex(x => x.sugestao == sugestao.sugestao);
      if (idx >= 0) {
        this.ideaData.sugestoes.splice(idx, 1);
      }
    }
  }

  loadTeamDepartments() {
    this.departmentsLoaded = false;
    this.loadingTeamDepartments = true;
    this.store.dispatch(new ListDepartmentsAction({ branchId: this.participante.unidadeId }));
    this.errorMessage = null;
  }

  loadTeamCollaborators() {
    this.teamCollaboratorsLoaded = false;
    this.store.dispatch(new ListCollaboratorsAction({ departmentId: this.participante.departamentoId }));
    this.errorMessage = null;
  }

  resizeTextArea() {
    let textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
    textArea.style.overflow = 'hidden';
    textArea.style.height = 'auto';
    textArea.style.height = (textArea.scrollHeight + 32) + 'px';
  }

  addParticipant() {
    this.participante = {
      id: null,
      nome: '',
      colaboradorId: null,
      departamentoId: null,
      unidadeId: null,
      usuarioId: null,
      usuarioEmail: null,
    }
    this.addingParticipant = true;
    this.errorMessage = null;
  }

  saveParticipant() {
    if (this.participante.unidadeId == null) {
      this.errorMessage = 5;
    } else if (this.participante.departamentoId == null) {
      this.errorMessage = 6;
    } else if (this.participante.colaboradorId == null) {
      this.errorMessage = 7;
    } else {
      const collaborator = this.collaboratorsTeamData.find(x => x.usuarioId == this.participante.colaboradorId);
      this.participante.nome = collaborator.nome;
      this.participante.usuarioId = collaborator.usuarioId;
      this.participante.usuarioEmail = collaborator.email;
      this.ideaData.times.push(this.participante);
      this.addingParticipant = false;
      this.participante = null;
      this.errorMessage = null;
    }
  }

  cancelParticipant() {
    this.addingParticipant = false;
    this.participante = null;
    this.errorMessage = null;
  }

  removeParticipant(idx: number) {
    this.ideaData.times.splice(idx, 1);
  }

  slidePrevious() {
    this.slides.lockSwipes(false);
    this.slides.slidePrev();
    this.cd.markForCheck();
    this.slides.lockSwipes(true);
  }

  slideNext() {
    if (this.validate()) {
      this.slides.lockSwipes(false);
      this.slides.slideNext();
      this.cd.markForCheck();
      this.slides.lockSwipes(true);
    }
  }

  calculatePaginationNext() {
    if (this.currentPage < this.totalPages) {
      this.currentPage = this.currentPage + 1;
    }
    this.showHideNextPrevious();
  }

  calculatePaginationPrev() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
    }
    this.showHideNextPrevious();
  }

  showHideNextPrevious() {
    this.paginationNextVisible = this.currentPage < this.totalPages;
    this.paginationPreviousVisible = this.currentPage > 1;
  }

  validate(): boolean {
    let valid: boolean = true;
    this.errorMessage = null;
    const slideId = this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-slideId');
    switch(slideId) {
      case '1':
        if (this.ideaData.sugestao == 1) {
          if (this.ideaData.times == null || this.ideaData.times.length == 0) {
            this.errorMessage = 1;
            valid = false;
          }
        }
        if (valid && this.ideaData.unidadeId == null || this.ideaData.unidadeId == 0) {
          this.errorMessage = 2;
          valid = false;
        }
        if (valid && this.ideaData.departamentoId == null || this.ideaData.departamentoId == 0) {
          this.errorMessage = 3;
          valid = false;
        }
        break;
      case '2':
        if (this.ideaData.ideia == null || this.ideaData.ideia == '') {
          this.errorMessage = 4;
          valid = false;
        }
        break;
      default:
        break;
    }
    return valid;
  }

  setImplementador(querImplementar: boolean) {
    this.ideaData.querImplementar = querImplementar;
  }

  send() {
    this.saving = true;
    this.ideaData.clienteId = this.clientId;
    this.ideaData.dataEnvio = new Date();
    this.ideaData.usuarioId = this.userId;
    this.ideaData.usuarioEmail = this.userEmail;
    this.store.dispatch(new SaveIdeaAction({ data: this.ideaData }));
  }

  cancel() {
    this.navCtrl.popToRoot();
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

  getUploadFileName(name: string) {
    this.fileInfo = name;
  }

  handleInputChange(e) {
    this.fileToUpload = null;
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        this.fileToUpload = files[key];
        break;
      }
    }
    if (this.fileToUpload != null) {
      this.fileInfo = this.fileToUpload.name;
    }
  }

  openFile() {
    const jsonArquivoIdeia = JSON.parse(this.ideaData.arquivoIdeia);
    let type = 'other';
    if (!jsonArquivoIdeia.url.match(/.(jpg|jpeg|png|gif)$/i)) {
      type = 'image';
    }
    this.navCtrl.push(CronosFilePage, { filename: jsonArquivoIdeia.nome, type: '', url: jsonArquivoIdeia.url });
  }

  isNumberKey(evt): boolean
  {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/brainstorm/brainstorm.ts